import { useQuery } from "@apollo/client";
import { LOAD_LATEST_STORIES } from "../graphql/queries";
import { useEffect, useState } from "react";

export default function useCategoryStories(category){

    const [items, setItems] = useState()

    const {error, loading, data} = useQuery(LOAD_LATEST_STORIES, {variables:{categoryName:category}})

    useEffect(()=>{

        if(data){
            console.log(items + "category")
            setItems(data.posts)
        }
    },[data])

    return {error, loading, items}
}